/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from "react"
import { CartProvider } from "src/context/CartContext"
import { ModalProvider } from "src/context/ModalContext"
import { UserProvider } from "src/context/UserContext"

import { Helmet } from "react-helmet"

export const wrapRootElement = ({ element }) => (
  <ModalProvider>
    <UserProvider>
      <Helmet
        script={[
          {
            type: "text/javascript",
            id: "google-maps-script",
            src: `https://maps.googleapis.com/maps/api/js?key=${process.env.GATSBY_GOOGLE_MAPS_API_KEY}&libraries=geometry,drawing,places`,
          },
          {
            type: "text/javascript",
            id: "prismic-preview",
            src: `https://static.cdn.prismic.io/prismic.js?new=true&repo=tag-suppliers-test-repo`,
          },
          {
            type: "text/javascript",
            id: "what3words",
            src: `https://assets.what3words.com/sdk/v3/what3words.js?key=${process.env.GATSBY_WHAT3WORDS_API_KEY}`,
          },
        ]}
      />
      <CartProvider>{element}</CartProvider>
    </UserProvider>
  </ModalProvider>
)
